<header class="go-page-title">
  <h1 class="go-heading-1">{{ pageTitle }}</h1>
  <a
  [href]="linkToSource"
  target="_blank">
    <go-button buttonVariant="neutral"> View on GitHub </go-button>
  </a>
</header>

<section class="go-container">
  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <!-- Intro -->
        <p class="go-body-copy">The <code class="code-block--inline">&lt;go-card&gt;</code> component should be the default container for all content.</p>
      </div>

      <div class="go-column go-column--100">
        <!-- Bindings -->
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <!-- expandAll -->
        <h4 class="go-heading-4">showHeader</h4>
        <p class="go-body-copy">
          <code class="code-block--inline">showHeader</code>
          by default is true, but if set to false it will hide the header
          of the card even if one is passed.
        </p>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="default">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Default</h2>
      <go-copy cardId="default" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h3 class="go-heading-3">Code (for this card)</h3>
      <code [highlight]="defaultExample"></code>
    </ng-container>
  </go-card>

  <go-card [showHeader]="false" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2">Default</h2>
    </ng-container>
    <ng-container go-card-content>
      <h3 class="go-heading-3">Code (for this card, no header example)</h3>
      <code [highlight]="showHeaderExample"></code>
    </ng-container>
  </go-card>

  <go-card class="go-column go-column--100" id="horizontal-rules">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">With Horizontal Rules</h2>
      <go-copy cardId="horizontal-rules" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">Full Width</h4>
      <p class="go-body-copy">
        A horizontal rule that spans the entire width of the card can be implemented by adding the
        <code class="code-block--inline">go-hr</code> class on an <code class="code-block--inline">hr</code> tag
        within the card's <code class="code-block--inline">go-card-content</code>.
      </p>
      <hr class="go-hr">
      <code
        [highlight]="hrExample"
        class="code-block">
      </code>

      <h4 class="go-heading-4">With Padding</h4>
      <p class="go-body-copy">
        Also adding the <code class="code-block--inline">go-hr--padding</code> modifier class will
        cause the width of the horizontal rule to respect the padding of the card containing it.
      </p>
      <hr class="go-hr go-hr--allow-padding">
      <code
        [highlight]="hrAllowPaddingExample"
        class="code-block">
      </code>
    </ng-container>
  </go-card>
</section>
